export const EMAILS = {
	support: 'support@passionapp.co',
};
